
  import { Vue, Component, Prop } from "vue-property-decorator";

  import DropdownFilter from "@/components/filters/DropdownFilter.vue";

  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })

  export default class SchedulerViewSelect extends Vue {
    @Prop({ type: Array, default: () => []}) value!: DropdownOption[];
    @Prop({ type: Boolean, default: true }) withBorder!: boolean;
    @Prop({ type: Boolean, default: false }) isAdmin!: boolean;

    get statusOptions(): DropdownOption[] {
      const managerViewOption = this.isAdmin
        ? {name: "View by managers", id: "View by managers"}
        : {name: "My schedule", id: "View by managers"};
      return [
        managerViewOption,
        {name: "View by projects", id: "View by projects"},
        {name: "View by contractors", id: "View by contractors"},
      ]
    }

    handleInput(input: DropdownOption[]): void {
      if (!input.length) {
        input = this.value;
      }
      this.$emit('input', input);
    }
  }
